import React, { useEffect, useState, useRef } from "react";
import "../App/App.scss";
import "../../css/bootstrap.css";
import "../KnovoMainScreen/KnovoMainScreen.css";
import "../KnovoClassesScreen/KnovoClassesScreen.css";
import { connect } from "react-redux";
import UserActions from "../../store/user/Actions";
import "../HomeScreen/HomeScreen.css";
import ClassItem from "../CommonItems/ClassItem";
import ClassesSkeleton from "../CommonItems/ClassesSkeleton";
import LessonPodItemSkeleton from "../CommonItems/LessonPodItemSkeleton";
import LessonPodItem from "../CommonItems/LessonPodItem";
import ActivityList from "../CommonItems/ActivityList";
import { Tab, Tabs, TabList } from "carbon-components-react";
import { Column, Grid } from "carbon-components-react";
import EmptyScreen from "../CommonItems/EmptyScreen";
import Images from "../../images";
import {
  GET_CHAPTERS,
  GET_COURSES,
  GET_FOLDERS,
  GET_LESSON_UNITS,
  GET_LESSONS,
} from "../../constants";
function KnovoClassesScreen(props) {
  const {
    user,
    token,
    selectedClass,
    selectedChapter,
    selectedFolder,
    lessonUnitDetails,
    navigationIndex,
    speechApi,
  } = props; // get local data
  const {
    getCourseListForStudent,
    getChapterListForStudent,
    getLessonFoldersForStudent,
    getAssignmentDataForStudent,
    getLessonUnitDetailsForStudent,
    refreshToken,
    userToken,
  } = props; //Api's
  const {
    setHeaderTitle,
    setShowHideLoader,
    saveCourseId,
    saveSubjectID,
    setCurrentLessonName,
    saveFromAnalytics,
    saveFromCourse,
    saveUnitName,
    saveFromPending,
    saveSelectedClass,
    saveSelectedChapter,
    saveSelectedFolder,
    setNavigationIndex,
    showOrHideToaster,
  } = props; //store local
  const [internalLoading, setInternalLoading] = useState(false);
  const [internalLoadingPopup, setInternalLoadingPopup] = useState(false);
  const [courseList, setCourseList] = useState([]);
  const [chapterList, setChapterList] = useState([]);
  const [lessonFolderList, setLessonFolderList] = useState([]);
  const [assignmentDataByStatus, setAssignmentDataByStatus] = useState({
    pending: [],
    working: [],
    rework: [],
    completed: [],
  });
  const [currentAssignmentsData, setCurrentAssignmentsData] = useState([]);
  // const [selectedAssaignmentData, setSelectedAssaignmentData] = useState({});
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [displayActivityModal, setDisplayActivityModal] = useState(false);

  const [saveUserErrorCount, setSaveUserErrorCount] = useState(0);
  const selectedAssaignmentData = useRef({});

  //Get all the classes
  useEffect(() => {
    setHeaderTitle("Course Dashboard");
    setShowHideLoader(false);
  }, []);

  useEffect(() => {
    if (navigationIndex === 0) {
      saveSelectedClass({});
      setInternalLoading(true);
      getCourseList(token);
    } else if (navigationIndex === 1) {
      var objectLength = Object.keys(selectedClass).length;
      if (objectLength > 0) {
        saveSelectedChapter({});
        getChapterList(token);
      }
    } else if (navigationIndex === 2) {
      var objectLength = Object.keys(selectedChapter).length;
      if (objectLength > 0) {
        saveSelectedFolder({});
        getFolderList(token);
      }
    } else if (navigationIndex === 3) {
      var objectLength = Object.keys(selectedFolder).length;
      if (objectLength > 0) {
        getAllLessons(token);
      }
    }
  }, [navigationIndex]);

  //Get course list
  function getCourseList(tokenData) {
    getCourseListForStudent(
      user.LoginID,
      tokenData,
      (courseListResponse) => {
        if (courseListResponse.StatusCode === 200) {
          setTimeout(() => {
            setSaveUserErrorCount(0);
            setInternalLoading(false);
            setShowHideLoader(false);
            setCourseList(courseListResponse.Data.GetBPStudentDashboardResult);
          }, 2000);
        } else if (courseListResponse.StatusCode === 401) {
          if (saveUserErrorCount < 1) {
            refreshTokenCall(GET_COURSES);
          } else {
            showOrHideToaster(
              true,
              "Server failed! Please try again.",
              "error"
            );
            setSaveUserErrorCount(0);
            setInternalLoading(false);
          }
        } else {
          setInternalLoading(false);
          showOrHideToaster(true, courseListResponse.StatusMessage, "error");
        }
      },
      (failureResponse) => {
        setSaveUserErrorCount(0);
        setInternalLoading(false);
        setShowHideLoader(false);
        setCourseList([]);
        console.log("failureResponse", failureResponse);
      }
    );
  }

  //Get chapter for selected class
  function getChapterList(tokenData) {
    setShowHideLoader(false);
    setInternalLoading(true);
    getChapterListForStudent(
      selectedClass.SubjectID,
      user.LoginID,
      tokenData,
      (chapterList) => {
        if (chapterList.StatusCode === 200) {
          setTimeout(() => {
            setSaveUserErrorCount(0);
            setInternalLoading(false);
            setShowHideLoader(false);
            setChapterList(chapterList.Data.GetAllChaptersBySubjectResult);
          }, 2000);
        } else if (chapterList.StatusCode === 401) {
          if (saveUserErrorCount < 1) {
            refreshTokenCall(GET_CHAPTERS);
          } else {
            showOrHideToaster(
              true,
              "Server failed! Please try again.",
              "error"
            );
            setSaveUserErrorCount(0);
            setInternalLoading(false);
          }
        } else {
          setInternalLoading(false);
          showOrHideToaster(true, chapterList.StatusMessage, "error");
        }
      },
      (failureResponse) => {
        setSaveUserErrorCount(0);
        setInternalLoading(false);
        setShowHideLoader(false);
        setChapterList([]);
      }
    );
  }

  function onCourseClick(courseId, courseName, SubjectID) {
    saveFromAnalytics(false);
    setShowHideLoader(true);
    saveCourseId(courseId);
    setCurrentLessonName(courseName);
    saveSubjectID(SubjectID);
    saveFromCourse(true);
  }

  //Get folders for selected chapter
  function getFolderList(tokenData) {
    setShowHideLoader(false);
    setInternalLoading(true);
    getLessonFoldersForStudent(
      user.LoginID,
      user.DomainID,
      selectedClass.SubjectID,
      selectedChapter.ChapterID,
      tokenData,
      (folderList) => {
        if (folderList.StatusCode === 200) {
          setTimeout(() => {
            setSaveUserErrorCount(0);
            setInternalLoading(false);
            setShowHideLoader(false);
            setLessonFolderList(
              folderList.Data.GetBPLessonFoldersBySubjectResult
            );
          }, 2000);
        } else if (folderList.StatusCode === 401) {
          if (saveUserErrorCount < 1) {
            refreshTokenCall(GET_FOLDERS);
          } else {
            showOrHideToaster(
              true,
              "Server failed! Please try again.",
              "error"
            );
            setSaveUserErrorCount(0);
            setInternalLoading(false);
          }
        } else {
          setInternalLoading(false);
          showOrHideToaster(true, folderList.StatusMessage, "error");
        }
      },
      (failureResponse) => {
        setSaveUserErrorCount(0);
        setInternalLoading(false);
        setShowHideLoader(false);
        setLessonFolderList([]);
      }
    );
  }

  //Get lessons for selected folder
  function getAllLessons(tokenData) {
    setInternalLoading(true);
    getAssignmentDataForStudent(
      user.LoginID,
      selectedClass.CourseID,
      selectedFolder.LessonID,
      selectedChapter.ChapterID,
      tokenData,
      (response) => {
        if (response.StatusCode === 200) {
          setTimeout(() => {
            setSaveUserErrorCount(0);
            let assignmentPendingData = response.Data.Pending;
            let pendingData = [];
            let workingData = [];
            let reworkData = [];
            if (assignmentPendingData.length > 0) {
              assignmentPendingData.map((assignDataItem) => {
                if (assignDataItem.Status === "Pending") {
                  //pendingData.push(assignDataItem);
                  workingData.push(assignDataItem);
                } else if (assignDataItem.Status === "Working") {
                  workingData.push(assignDataItem);
                  // pendingData.push(assignDataItem);
                } else if (assignDataItem.Status === "Rework") {
                  reworkData.push(assignDataItem);
                }
              });
            }
            let assignmentDataByStatusCopy = { ...assignmentDataByStatus };
            let assignmentCompletedData = response.Data.Completed;
            assignmentDataByStatusCopy.pending = pendingData;
            assignmentDataByStatusCopy.working = workingData;
            assignmentDataByStatusCopy.rework = reworkData;
            assignmentDataByStatusCopy.completed = assignmentCompletedData;
            setAssignmentDataByStatus(assignmentDataByStatusCopy);
            setInternalLoading(false);
          }, 2000);
        } else if (response.StatusCode === 401) {
          if (saveUserErrorCount < 1) {
            refreshTokenCall(GET_LESSONS);
          } else {
            showOrHideToaster(
              true,
              "Server failed! Please try again.",
              "error"
            );
            setSaveUserErrorCount(0);
            setInternalLoading(false);
          }
        } else {
          setInternalLoading(false);
          showOrHideToaster(true, response.StatusMessage, "error");
        }
      }
    );
  }

  useEffect(() => {
    if (selectedTabIndex === -1) {
      setCurrentAssignmentsData(assignmentDataByStatus.pending);
    } else if (selectedTabIndex === 0) {
      setCurrentAssignmentsData(assignmentDataByStatus.working);
    } else if (selectedTabIndex === 1) {
      setCurrentAssignmentsData(assignmentDataByStatus.completed);
    }
  }, [selectedTabIndex, assignmentDataByStatus]);

  function getLessonUnitDetails(lessonUnitDistId, lessonUnitName, tokenData) {
    setDisplayActivityModal(true);
    setInternalLoadingPopup(true);
    saveUnitName(lessonUnitName);
    saveFromPending(true);
    getLessonUnitDetailsForStudent(
      user.LoginID,
      lessonUnitDistId,
      tokenData,
      (activityListResponse) => {
        if (activityListResponse.StatusCode === 200) {
          setTimeout(() => {
            setSaveUserErrorCount(0);
            setInternalLoading(false);
            setInternalLoadingPopup(false);
          }, 2000);
        } else if (activityListResponse.StatusCode === 401) {
          if (saveUserErrorCount < 1) {
            refreshTokenCall(GET_LESSON_UNITS);
          } else {
            showOrHideToaster(
              true,
              "Server failed! Please try again.",
              "error"
            );
            setSaveUserErrorCount(0);
            setInternalLoading(false);
            setInternalLoadingPopup(false);
          }
        } else {
          setInternalLoading(false);
          setInternalLoadingPopup(false);
          showOrHideToaster(true, activityListResponse.StatusMessage, "error");
        }
      }
    );
  }

  function refreshTokenCall(apiType) {
    refreshToken(token, (tokenResponse) => {
      if (tokenResponse.Success) {
        if (apiType === GET_COURSES) {
          getCourseList(tokenResponse.Token);
        } else if (apiType === GET_CHAPTERS) {
          getChapterList(tokenResponse.Token);
        } else if (apiType === GET_FOLDERS) {
          getFolderList(tokenResponse.Token);
        } else if (apiType === GET_LESSONS) {
          getAllLessons(tokenResponse.Token);
        } else if (apiType === GET_LESSON_UNITS) {
          getLessonUnitDetails(
            selectedAssaignmentData.current.LessonUnitDistID,
            selectedAssaignmentData.current.LessonName,
            tokenResponse.Token
          );
        }
        userToken(tokenResponse.Token);
        setSaveUserErrorCount(1);
      } else {
        showOrHideToaster(true, "Server failed! Please try again.", "error");
        setSaveUserErrorCount(0);
        setInternalLoading(false);
      }
    });
  }

  function getFormattedDateChange(dateValue) {
    var dateFormat = "";
    if (dateValue && dateValue !== "") {
      var dt = new Date(dateValue);
      var months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      var day = dt.getDate().toString();
      day = day.length > 1 ? day : "0" + day;
      dateFormat = day + " " + months[dt.getMonth()];
    } else {
      dateFormat = "";
    }
    return dateFormat;
  }

  const lessonItemColorOdd = ["#4922fd", "#3ec986"];
  const lessonItemColorEven = ["#00b2ff", "#FFC42D"];

  function getRandomItem(arr) {
    // get random index value
    const randomIndex = Math.floor(Math.random() * arr.length);
    // get random item
    const item = arr[randomIndex];
    return item;
  }

  function renderCourseList() {
    if (courseList.Course && courseList.Course.length > 0) {
      return (
        <Grid className="home-grid-style" condensed fullWidth>
          {courseList.Course &&
            courseList.Course.map((courseItem, index) => {
              return (
                <Column
                  key={"course-" + index}
                  className="course-column-style"
                  lg={4}
                  md={4}
                  sm={4}
                  onClick={() => {
                    saveSelectedClass(courseItem);
                    setNavigationIndex(1);
                    onCourseClick(
                      courseItem.CourseID,
                      courseItem.CourseName,
                      courseItem.SubjectID
                    );
                  }}
                >
                  <ClassItem
                    CourseImage={courseItem.ImageURL}
                    CourseName={courseItem.CourseName}
                    TeacherName={courseItem.TeacherName}
                    isClass={true}
                  />
                </Column>
              );
            })}
        </Grid>
      );
    } else {
      return (
        <EmptyScreen
          imageAnime={Images.empty_anim_3}
          emptyMessage={"Looks like you don’t have any classes"}
        />
      );
    }
  }

  function renderChapterList() {
    if (chapterList && chapterList.length > 0) {
      return (
        <Grid className="home-grid-style" condensed fullWidth>
          {chapterList &&
            chapterList.map((chapterItem, index) => {
              return (
                <Column
                  key={"class-" + index}
                  className="course-column-style"
                  lg={4}
                  md={4}
                  sm={4}
                  onClick={() => {
                    saveSelectedChapter(chapterItem);
                    setNavigationIndex(2);
                  }}
                >
                  <ClassItem
                    CourseImage={chapterItem.ImageURL}
                    CourseName={chapterItem.ChapterName}
                    TeacherName={""}
                    isClass={true}
                  />
                </Column>
              );
            })}
        </Grid>
      );
    } else {
      return (
        <EmptyScreen
          imageAnime={Images.empty_anim_3}
          emptyMessage={"Looks like you don’t have any chapter"}
        />
      );
    }
  }

  function renderFolderList() {
    if (lessonFolderList && lessonFolderList.length > 0) {
      return (
        <Grid className="home-grid-style" condensed fullWidth>
          {lessonFolderList &&
            lessonFolderList.map((folderItem, index) => {
              return (
                <Column
                  key={"folder" + index}
                  className="course-column-style"
                  lg={4}
                  md={4}
                  sm={4}
                  onClick={() => {
                    setNavigationIndex(3);
                    saveSelectedFolder(folderItem);
                  }}
                >
                  <ClassItem
                    CourseImage={folderItem.ImageURL}
                    CourseName={folderItem.LessonName}
                    TeacherName={""}
                    isClass={true}
                  />
                </Column>
              );
            })}
        </Grid>
      );
    } else {
      return (
        <EmptyScreen
          imageAnime={Images.empty_anim_3}
          emptyMessage={"Looks like you don’t have any folder"}
        />
      );
    }
  }

  function renderLessonsData() {
    if (currentAssignmentsData && currentAssignmentsData.length > 0) {
      return (
        <Grid className="home-grid-style" condensed fullWidth>
          {currentAssignmentsData &&
            currentAssignmentsData.map((assignment, index) => {
              return (
                <Column
                  key={"lesson" + index}
                  className="home-column-style"
                  lg={4}
                  md={4}
                  sm={4}
                  onClick={() => {
                    // setSelectedAssaignmentData(assignment);
                    selectedAssaignmentData.current = assignment;
                    getLessonUnitDetails(
                      assignment.LessonUnitDistID,
                      assignment.LessonName,
                      token
                    );
                  }}
                >
                  <LessonPodItem
                    CourseName=""
                    LessonName={assignment.LessonName}
                    DueDate={getFormattedDateChange(
                      assignment.TargetCompletionDateTime
                    )}
                    LessonColor={
                      index % 2
                        ? getRandomItem(lessonItemColorEven)
                        : getRandomItem(lessonItemColorOdd)
                    }
                  />
                </Column>
              );
            })}
        </Grid>
      );
    } else {
      return (
        <EmptyScreen
          imageAnime={Images.empty_anim_3}
          emptyMessage={"Looks like you don’t have any lessons to complete"}
        />
      );
    }
  }

  return (
    <div className="knovo-classes-container">
      <div className="classes-navigation-item">
        {navigationIndex === 0 ? (
          <Tabs selectedIndex={navigationIndex} defaultChecked={0}>
            <TabList aria-label="List of tabs">
              <Tab>Classes</Tab>
            </TabList>
          </Tabs>
        ) : navigationIndex === 1 ? (
          <Tabs selectedIndex={navigationIndex} defaultChecked={1}>
            <TabList aria-label="List of tabs">
              <Tab
                className="navigation-tab-label"
                onClick={() => {
                  setNavigationIndex(0);
                  setSelectedTabIndex(0);
                }}
              >
                {selectedClass.CourseName}
              </Tab>
              <Tab>Chapters</Tab>
            </TabList>
          </Tabs>
        ) : navigationIndex === 2 ? (
          <Tabs selectedIndex={navigationIndex} defaultChecked={2}>
            <TabList aria-label="List of tabs">
              <Tab
                onClick={() => {
                  setNavigationIndex(0);
                  setSelectedTabIndex(0);
                }}
              >
                {selectedClass.CourseName}
              </Tab>
              <Tab
                onClick={() => {
                  setNavigationIndex(1);
                  setSelectedTabIndex(0);
                }}
              >
                {selectedChapter.ChapterName}
              </Tab>
              <Tab>Lesson Folders</Tab>
            </TabList>
          </Tabs>
        ) : (
          <Tabs selectedIndex={navigationIndex} defaultChecked={3}>
            <TabList aria-label="List of tabs">
              <Tab
                onClick={() => {
                  setNavigationIndex(0);
                  setSelectedTabIndex(0);
                }}
              >
                {selectedClass.CourseName}
              </Tab>
              <Tab
                onClick={() => {
                  setNavigationIndex(1);
                  setSelectedTabIndex(0);
                }}
              >
                {selectedChapter.ChapterName}
              </Tab>
              <Tab
                onClick={() => {
                  setNavigationIndex(2);
                  setSelectedTabIndex(0);
                }}
              >
                {selectedFolder.LessonName}
              </Tab>
              <Tab>Lessons</Tab>
            </TabList>
          </Tabs>
        )}
      </div>
      <div
        className={
          navigationIndex === 3
            ? "classes-canvas-container-lesson"
            : "classes-canvas-container"
        }
      >
        <div className="assignment-navigation-container">
          <div className="assignment-navigation">
            {navigationIndex === 3 && (
              <Tabs
                selectedIndex={selectedTabIndex}
                defaultChecked={selectedTabIndex}
              >
                <TabList aria-label="List of lesson tabs">
                  {/* <Tab
                    onClick={() => {
                      setSelectedTabIndex(0);
                    }}
                  >
                    Not Started
                  </Tab> */}
                  <Tab
                    onClick={() => {
                      setSelectedTabIndex(0);
                    }}
                  >
                    Working
                  </Tab>
                  <Tab
                    onClick={() => {
                      setSelectedTabIndex(1);
                    }}
                  >
                    Completed
                  </Tab>
                </TabList>
              </Tabs>
            )}
          </div>
        </div>
        {internalLoading ? (
          <div className="data-container">
            {navigationIndex === 3 ? (
              <Grid className="home-grid-style" condensed fullWidth>
                {Array.from(Array(8)).map((assignment, index) => {
                  return (
                    <Column
                      key={"lesson_skel" + index}
                      className="home-column-style"
                      lg={4}
                      md={4}
                      sm={4}
                    >
                      <LessonPodItemSkeleton />
                    </Column>
                  );
                })}
              </Grid>
            ) : (
              <Grid className="home-grid-style" condensed fullWidth>
                {Array.from(Array(8)).map((assignment, index) => {
                  return (
                    <Column
                      key={"class_skel" + index}
                      className="home-column-style"
                      lg={4}
                      md={4}
                      sm={4}
                    >
                      <ClassesSkeleton />
                    </Column>
                  );
                })}
              </Grid>
            )}
          </div>
        ) : (
          <div className="data-container">
            {navigationIndex === 0
              ? renderCourseList()
              : navigationIndex === 1
              ? renderChapterList()
              : navigationIndex === 2
              ? renderFolderList()
              : renderLessonsData()}
          </div>
        )}
      </div>

      {displayActivityModal && (
        <ActivityList
          activityListData={
            lessonUnitDetails.Data &&
            lessonUnitDetails.Data.GetLessonUnitDetailsForAStudentResult &&
            lessonUnitDetails.Data.GetLessonUnitDetailsForAStudentResult
              .length > 0
              ? lessonUnitDetails.Data.GetLessonUnitDetailsForAStudentResult
              : []
          }
          selectedCourseName={
            selectedClass.CourseName ? selectedClass.CourseName : ""
          }
          selectedLessonName={
            selectedAssaignmentData.current.LessonName
              ? selectedAssaignmentData.current.lLessonName
              : ""
          }
          selectedTargetDate={
            selectedAssaignmentData.current.TargetCompletionDateTime
              ? getFormattedDateChange(
                  selectedAssaignmentData.current.TargetCompletionDateTime
                )
              : ""
          }
          onCloseClick={() => {
            setDisplayActivityModal(false);
          }}
          internalLoading={internalLoadingPopup}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user.user,
  token: state.user.token,
  lessonUnitDetails: state.user.lessonUnitDetails,
  navigationIndex: state.user.navigationIndex,
  selectedClass: state.user.selectedClass,
  selectedChapter: state.user.selectedChapter,
  selectedFolder: state.user.selectedFolder,
  speechApi: state.user.speechApi,
});

const mapDispatchToProps = (dispatch) => ({
  getCourseListForStudent: (loginId, token, successFn, failureFn) =>
    dispatch(
      UserActions.getCourseListForStudent(loginId, token, successFn, failureFn)
    ),
  getCourseSummaryAnalyticsReport: (DomainID, courseId, studentId, successFn) =>
    dispatch(
      UserActions.getCourseSummaryAnalyticsReport(
        DomainID,
        courseId,
        studentId,
        successFn
      )
    ),
  saveCourseId: (currentCourseId) =>
    dispatch(UserActions.saveCourseId(currentCourseId)),
  saveUnitName: (unitName) => dispatch(UserActions.saveUnitName(unitName)),
  saveSubjectID: (SubjectID) => dispatch(UserActions.saveSubjectID(SubjectID)),
  getChapterListForStudent: (subjectId, loginId, token, successFn, failureFn) =>
    dispatch(
      UserActions.getChapterListForStudent(
        subjectId,
        loginId,
        token,
        successFn,
        failureFn
      )
    ),
  getLessonFoldersForStudent: (
    studentId,
    DomainID,
    SubjectID,
    ChapterID,
    token,
    successFn,
    failureFn
  ) =>
    dispatch(
      UserActions.getLessonFoldersForStudent(
        studentId,
        DomainID,
        SubjectID,
        ChapterID,
        token,
        successFn,
        failureFn
      )
    ),
  getAssignmentDataForStudent: (
    studentId,
    courseId,
    lessonId,
    ChapterID,
    token,
    successFn
  ) =>
    dispatch(
      UserActions.getAssignmentDataForStudent(
        studentId,
        courseId,
        lessonId,
        ChapterID,
        token,
        successFn
      )
    ),
  getLessonUnitDetailsForStudent: (
    studentId,
    lessonUnitDistId,
    token,
    successFn
  ) =>
    dispatch(
      UserActions.getLessonUnitDetailsForStudent(
        studentId,
        lessonUnitDistId,
        token,
        successFn
      )
    ),
  setHeaderTitle: (headerTitle) =>
    dispatch(UserActions.setHeaderTitle(headerTitle)),
  setShowHideLoader: (status) =>
    dispatch(UserActions.setShowHideLoader(status)),
  saveFromAnalytics: (fromAnalytics) =>
    dispatch(UserActions.saveFromAnalytics(fromAnalytics)),
  setCurrentLessonName: (currentLessonName) =>
    dispatch(UserActions.setCurrentLessonName(currentLessonName)),
  saveFromCourse: (fromCourse) =>
    dispatch(UserActions.saveFromCourse(fromCourse)),
  saveUnitName: (unitName) => dispatch(UserActions.saveUnitName(unitName)),
  saveFromPending: (fromPending) =>
    dispatch(UserActions.saveFromPending(fromPending)),
  saveSelectedClass: (selectedClass) =>
    dispatch(UserActions.saveSelectedClass(selectedClass)),
  saveSelectedChapter: (selectedChapter) =>
    dispatch(UserActions.saveSelectedChapter(selectedChapter)),
  saveSelectedFolder: (selectedFolder) =>
    dispatch(UserActions.saveSelectedFolder(selectedFolder)),
  setNavigationIndex: (navigationIndex) =>
    dispatch(UserActions.setNavigationIndex(navigationIndex)),
  showOrHideToaster: (showToastModal, toastMessageText, toastType) =>
    dispatch(
      UserActions.showOrHideToaster(showToastModal, toastMessageText, toastType)
    ),
  refreshToken: (tokenData, successFn) =>
    dispatch(UserActions.refreshToken(tokenData, successFn)),
  userToken: (token) => dispatch(UserActions.userToken(token)),
});
export default connect(mapStateToProps, mapDispatchToProps)(KnovoClassesScreen);
